import React, { useRef, useEffect } from "react";

// Warm retro confetti/spark particles (diner neon palette).
export default function Particles({ density = 42, className = "" }) {
  const canvasRef = useRef(null);
  const mouse = useRef({ x: -999, y: -999 });

  useEffect(() => {
    const canvas = canvasRef.current;
    if (!canvas) return;
    const ctx = canvas.getContext("2d");
    let w, h, raf;
    const colors = ["255,81,71", "47,208,198", "246,182,74", "246,236,212"];
    let dots = [];

    const resize = () => {
      w = canvas.width = canvas.offsetWidth;
      h = canvas.height = canvas.offsetHeight;
      const count = Math.min(density, Math.floor((w * h) / 26000));
      dots = Array.from({ length: count }, () => ({
        x: Math.random() * w, y: Math.random() * h,
        s: Math.random() * 2.2 + 1.4,
        vx: (Math.random() - 0.5) * 0.22, vy: (Math.random() - 0.5) * 0.22,
        c: colors[Math.floor(Math.random() * colors.length)],
        a: Math.random() * 0.5 + 0.3,
      }));
    };

    const draw = () => {
      ctx.clearRect(0, 0, w, h);
      dots.forEach((d) => {
        d.x += d.vx; d.y += d.vy;
        const dx = d.x - mouse.current.x, dy = d.y - mouse.current.y;
        const dist = Math.sqrt(dx * dx + dy * dy);
        if (dist < 100) { d.x += (dx / dist) * 0.6; d.y += (dy / dist) * 0.6; }
        if (d.x < 0) d.x = w; if (d.x > w) d.x = 0;
        if (d.y < 0) d.y = h; if (d.y > h) d.y = 0;
        ctx.beginPath();
        ctx.fillStyle = `rgba(${d.c},${d.a})`;
        ctx.shadowBlur = 8;
        ctx.shadowColor = `rgba(${d.c},0.6)`;
        ctx.arc(d.x, d.y, d.s, 0, Math.PI * 2);
        ctx.fill();
      });
      ctx.shadowBlur = 0;
      raf = requestAnimationFrame(draw);
    };

    resize(); draw();
    const onMove = (e) => { const rect = canvas.getBoundingClientRect(); mouse.current = { x: e.clientX - rect.left, y: e.clientY - rect.top }; };
    window.addEventListener("resize", resize);
    canvas.addEventListener("mousemove", onMove);
    return () => { cancelAnimationFrame(raf); window.removeEventListener("resize", resize); canvas.removeEventListener("mousemove", onMove); };
  }, [density]);

  return <canvas ref={canvasRef} aria-hidden="true" className={className} style={{ width: "100%", height: "100%" }} />;
}
